var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCheckVerified(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 35,
    height: 33.478,
    viewBox: "0 0 35 33.478",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M36 18.239l-3.882-4.448.541-5.883L26.916 6.6l-3.007-5.1L18.5 3.828 13.091 1.5l-3.007 5.086-5.743 1.291.541 5.9L1 18.239l3.882 4.448-.541 5.9 5.743 1.307 3.007 5.086 5.409-2.345 5.409 2.328 3.007-5.086 5.743-1.307-.541-5.883zm-20.539 7.525L9.416 19.69l2.354-2.36 3.691 3.714 9.307-9.358 2.355 2.359z",
    transform: "translate(-1 -1.5)"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCheckVerified);
export default __webpack_public_path__ + "static/media/check-verified.10e8e836fe4eae6e43b9040c5c8183b8.svg";
export { ForwardRef as ReactComponent };